import { render } from "./FazerRelato.vue?vue&type=template&id=3952034e&scoped=true"
import script from "./FazerRelato.vue?vue&type=script&lang=js"
export * from "./FazerRelato.vue?vue&type=script&lang=js"

import "./FazerRelato.vue?vue&type=style&index=0&id=3952034e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3952034e"]])

export default __exports__